// extracted by mini-css-extract-plugin
export var auto = "_27-1";
export var spinner = "_27-0";